/*
Let's one element toggle a sidebar (or could be used like a generic remote toggle panel)
Sidebars manipulate column counts as well. For a fixed "sidebar" use a drawer
*/

(function ($) {
    $.fn.sidebar = function(options) {
        var defaults = {
            accordion: undefined
        };

        options = $.extend(defaults, options);


        return this.each(function() {

            var $this = $(this);
            var sSidebarSel = $this.data("sidebar");
            var $sidebar = $(sSidebarSel);
            var bStartOpen = $sidebar.is(".is-open");
            var nColumns = parseInt($sidebar.attr("column"));


            // Add click handler
            $this.on('click', function(e) {
                var bHasPrev = $sidebar.prev().length > 0;
                var bHasNext = $sidebar.next().length > 0;
                var $sibling;
                if(bHasPrev){
                    $sibling = $sidebar.prev();
                } else if(bHasNext) {
                    $sibling = $sidebar.next();
                }

                if($sidebar.hasClass("is-open")) {
                    // Visible already. Hide and add column size to neighbour
                    var nCurrentColumns = parseInt($sibling.attr("column"));
                    $sidebar.removeClass('swashIn');
                    $sidebar.addClass('animated animated--quickly swashOut');
                    $this.removeClass('is-active');
                    setTimeout(function () {
                        $sidebar.removeClass('is-open');
                        $sibling.attr("column", nCurrentColumns + nColumns);
                    }, 500);
                } else {
                    // Hidden. Show and subtract column size to neighbour
                    var nCurrentColumns = parseInt($sibling.attr("column"));
                    $sibling.attr("column", nCurrentColumns - nColumns);
                    $sidebar.removeClass('swashOut');
                    $sidebar.addClass('animated animated--quickly swashIn is-open');
                    $this.addClass('is-active');
                }
            });


});
};

$(document).ready(function(){
    $(".sidebar-trigger").sidebar();
});
}( jQuery ));
